import { ConfigFilterSet } from '@/types/userConfigs';
import { convertGameFilterValuesToPersistedValues } from '@/utils/persistedFilters';
import { filterAtomDefaults } from '../defaults/filterAtomDefaults';
import { gameTypeOptions } from '../gameMetrics';
import { GAME_RANGE_OPTIONS, PERIOD_RANGES } from '../gameRange';
import { MIN_MINUTES } from './ranges';

export const TEMPORARY_FILTER_SET_ID = 'TEMP_FILTER_SET' as const;

// the perspective is carried across team tabs, never saved to a filter set
const { eventsPerspective: _eventsPerspective, ...savableFilterAtomDefaults } = filterAtomDefaults;

export const TEMPORARY_FILTER_SET_BASE_FILTERS: ConfigFilterSet = {
  ...savableFilterAtomDefaults,
  ...convertGameFilterValuesToPersistedValues({
    periodRangeToConvert: PERIOD_RANGES.allGames,
    gameRangeToConvert: GAME_RANGE_OPTIONS.period,
    gameTypeToConvert: gameTypeOptions[0],
  }),
  minMinutes: MIN_MINUTES,
  seasonIds: [],
  competitionIds: [],
  eventFilterGroups: [],
};
